import { ServiceBase } from '../../../../../core/services/ServiceBase'
import Proxy from './Proxy'

class Service extends ServiceBase {
  getFollowSettings(params) {
    return this.getData(() => Proxy.getFollowSettings(params))
  }

  saveFollowSettings(params) {
    return this.getData(() => Proxy.saveFollowSettings(params), true)
  }

  getAlertSettings(params) {
    return this.getData(() => Proxy.getAlertSettings(params))
  }
}

export default new Service()
